module.exports = __webpack_public_path__ + "static/media/Rubik-Black.1df1a3bb.woff";